import { useList } from '@refinedev/core';
import type { CrudFilters } from '@refinedev/core';

/**
 * How many rows of `resource` match `filters` — the list endpoint's `total`
 * read off a one-row page, there being no dedicated count endpoint.
 */
export const useResourceCount = (resource: string, filters: CrudFilters) => {
  const { query } = useList({
    resource,
    filters,
    pagination: { pageSize: 1 },
  });
  return {
    total: query.data?.total,
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
